// podcastData.js
const podcastData = [
    { title: 'Frontend Development Basics', host: 'Chinonso Okeke', audioLink: 'https://www.youtube.com/watch?v=KWX8lzzzrzA' },
    { title: 'Backend Deep Dive', host: 'Amina Yusuf', audioLink: 'https://example.com/audio/backend.mp3' },
    { title: 'Fullstack Mastery', host: 'Emeka Nwankwo', audioLink: 'https://example.com/audio/fullstack.mp3' },
    { title: 'Design for Developers', host: 'Ngozi Uche', audioLink: 'https://example.com/audio/design.mp3' },
    { title: 'Engineering Principles', host: 'Tunde Balogun', audioLink: 'https://example.com/audio/engineering.mp3' },
    { title: 'Data Science Essentials', host: 'Zainab Mohammed', audioLink: 'https://example.com/audio/datascience.mp3' },
    // Add more podcasts as needed
  ];
  
  export default podcastData;
  